"use strict";
/**
 * This module is a set of functions to deal with file extensions
 * Usage:
 * `import { functionName } from 'priority_utils/lib/fileExtensions'`
 *
 */
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileIconName = exports.getIconName = exports.IconName = exports.isImage = exports.getExtension = exports.mobileImageFormats = exports.webImageFormats = void 0;
exports.webImageFormats = [
    'jpg',
    'jpeg',
    'gif',
    'tif',
    'tiff',
    'png',
    'bmp',
    'pjpeg',
    'ico',
    'svg',
    'webp',
    'apng',
];
exports.mobileImageFormats = ['jpeg', 'jpg', 'png', 'gif', 'webp', 'bmp'];
var imageFormats = {
    web: exports.webImageFormats,
    mobile: exports.mobileImageFormats,
};
/**
 * Returns the file extension according to recived file uri
 * @param {string} fileUri The file uri
 */
function getExtension(fileUri) {
    if (fileUri === void 0) { fileUri = ''; }
    var splitted = fileUri.split('.');
    if (splitted && splitted.length > 1) {
        return splitted[splitted.length - 1];
    }
    else {
        return '';
    }
}
exports.getExtension = getExtension;
/**
 * Return boolean indicating if the file is an image according to the passed file uri
 * @param {string} fileUri The fiel uri
 * @param {'web' | 'mobile'} platform Supported image extensions change according to the platform they are rendred
 */
function isImage(fileUri, platform) {
    var formats = imageFormats[platform];
    var extension = getExtension(fileUri);
    return formats.indexOf(extension.toLowerCase()) > -1;
}
exports.isImage = isImage;
var IconName;
(function (IconName) {
    IconName["pdf"] = "pdf";
    IconName["excel"] = "excel";
    IconName["txt"] = "txt";
    IconName["doc"] = "doc";
    IconName["ppt"] = "ppt";
    IconName["msg"] = "msg";
    IconName["img"] = "img";
})(IconName = exports.IconName || (exports.IconName = {}));
var icons = (_a = {},
    _a[IconName.pdf] = 'pdf',
    _a);
var extensionToIcon = {
    pdf: 'pdf',
    jpeg: 'img',
    jpg: 'img',
    tif: 'img',
    png: 'img',
    gif: 'img',
    webp: 'img',
    svg: 'img',
    tiff: 'img',
    bmp: 'img',
    tsg: 'img',
    pptx: 'ppt',
    pptm: 'ppt',
    ppt: 'ppt',
    potx: 'ppt',
    potm: 'ppt',
    pot: 'ppt',
    ppsx: 'ppt',
    ppsm: 'ppt',
    pps: 'ppt',
    ppam: 'ppt',
    ppa: 'ppt',
    odp: 'ppt',
    xlsx: 'excel',
    xlsm: 'excel',
    xlsb: 'excel',
    xls: 'excel',
    xltx: 'excel',
    xltm: 'excel',
    xlt: 'excel',
    xlam: 'excel',
    xla: 'excel',
    ods: 'excel',
    docx: 'doc',
    docm: 'doc',
    doc: 'doc',
    dotx: 'doc',
    dotm: 'doc',
    dot: 'doc',
    odt: 'doc',
    trf: 'doc',
    msg: 'msg',
    txt: 'txt',
};
/**
 * Returns the icon name according to the file extension
 * @param {string} fileExtension The file extension
 */
function getIconName(fileExtension) {
    if (fileExtension === void 0) { fileExtension = ''; }
    return extensionToIcon[fileExtension] ? extensionToIcon[fileExtension] : '';
}
exports.getIconName = getIconName;
/**
 * Returns the icon name according to the file type
 * @param {string} fileUri The file uri
 */
function getFileIconName(fileUri) {
    var fileExtension = getExtension(fileUri);
    return getIconName(fileExtension);
}
exports.getFileIconName = getFileIconName;
